module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 86.07fa35fe.png";